import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../config/publicPageSeo";
import { getStructuredDataForPath } from "../config/structuredDataPages";
import { buildGlobalSchemas, serializeStructuredData } from "../utils/structuredData";

const SCRIPT_ID = "lesson-launchpad-structured-data";

function StructuredData() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageSchemas = getStructuredDataForPath(pathname) || [];
    const seo = getSeoForPath(pathname);
    const schemas = seo ? [...buildGlobalSchemas(), ...pageSchemas] : buildGlobalSchemas();
    const payload = serializeStructuredData(schemas);

    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }

    script.textContent = payload ? JSON.stringify(payload) : "";

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [pathname]);

  return null;
}

export default StructuredData;
